<template>
  <div>
    <div class="content_box row-column acea-row row-center-wrapper">
      <div
        :style="`backgroundImage: url(` + topHeaderImg + `)`"
        class="header_box row-column acea-row row-center-wrapper"
      >
        <div class="item">产品中心</div>
        <div class="item_small">-PRODUCT CONTER-</div>
      </div>
      <div class="acea-row row-column row-center-wrapper top_big_small_box">
        <div class="about_top_box acea-row row-middle">
          <div class="gary_text">{{ groupName }}</div>
        </div>
      </div>
      <div class="productList_content row-column acea-row row-center-wrapper">
        <productList :productList="productList"></productList>
      </div>
    </div>
  </div>
</template>
<script>
import productList from "@/components/productList2/index";
export default {
  name: "qualifications",
  data() {
    return {
      topHeaderImg: require("@/assets/productConter/topbg1.png"),
      groupName: "三相重合闸系列", //产品类型名称
      productList: [
        {
          name: "PSS-50A",
          productImg: require("@/assets/productConter/goods/threePhase_good1.png"),
          paramsImg: require("@/assets/productConter/params/PSS-50A.png"),
          paramsminiImg: require("@/assets/productConter/params/mini/PSS-50A.png"),
          size: "135*96*65",
          tableDataRight:[
            {technicalIndicators:"分断极数:",performanceDesc:'3P+1'},
            {technicalIndicators:"工作环境(温、湿度): ",performanceDesc:'-40°C-85°C/≤909%'},
            {technicalIndicators:"外型尺寸(HxWxDmm): ",performanceDesc:'135*96*65'},
            {technicalIndicators:"产品功能指示灯:",performanceDesc:'运行、缺相、欠压、过压、漏电、输出、防雷、通信'},
            {technicalIndicators:"输入额定电压:",performanceDesc:'3x220V/380V AC 5OHz'},
            {technicalIndicators:"额定电流(In):",performanceDesc:'PSS-50A:不可调'},
            {technicalIndicators:"过压保护值:",performanceDesc:'280V±10V'},
            {technicalIndicators:"过压合闸值:",performanceDesc:'<275v'}
          ],
          tableDataLeft:[
            {technicalIndicators:"欠压保护值:",performanceDesc:'150V主10V'},
            {technicalIndicators:"欠压合闸值:",performanceDesc:'>155V'},
            {technicalIndicators:"过、欠压保护动作时间:",performanceDesc:'<0.25'},
            {technicalIndicators:"剩余动作电流值及动作时间:",performanceDesc:'30mA,<0.1s'},
            {technicalIndicators:"漏电不动作电流",performanceDesc:'漏电不动作电流:15mA'},
            {technicalIndicators:"自动重合闸特性:",performanceDesc:'线路发生瞬间漏电或瞬间冲击雷电、电压时,自动重合闸漏电保护器立即断开;故障过后,线路如是安全，保护器会自动重新合闸通电。'},
            {technicalIndicators:"跳闸时间:",performanceDesc:'1分钟/2分钟/5分钟/30分钟/60分-10次'}
          ]
        },
        {
          name: "PSS-80AS",
          productImg: require("@/assets/productConter/goods/threePhase_good2.png"),
          paramsImg: require("@/assets/productConter/params/PSS-80AS.png"),
          paramsminiImg: require("@/assets/productConter/params/mini/PSS-80AS.png"),
          size: "150*112*65",
          tableDataRight:[
            {technicalIndicators:"分断极数:",performanceDesc:'3P+1'},
            {technicalIndicators:"工作环境(温、湿度):",performanceDesc:'-40°C-85°C/≤90%'},
            {technicalIndicators:"外型尺寸(HxWxDmm):",performanceDesc:'150*112*65'},
            {technicalIndicators:"产品功能指示灯:",performanceDesc:'运行、缺相、欠压、过压、漏电、输出、防雷、通信'},
            {technicalIndicators:"输入额定电压:",performanceDesc:'3x220V/380V AC 50Hz'},
            {technicalIndicators:"额定电流(In):",performanceDesc:'32A-63A-80A'},
            {technicalIndicators:"过压保护值:",performanceDesc:'280V±10v'},
            {technicalIndicators:"过压合闸值:",performanceDesc:'150V士10v'}
          ],
          tableDataLeft:[
            {technicalIndicators:"欠压合闸值:",performanceDesc:'>155V'},
            {technicalIndicators:"过、欠压保护动作时间:",performanceDesc:'<0.2s'},
            {technicalIndicators:"过载保护值及动作时间:",performanceDesc:'>ln*1.15,<2s'},
            {technicalIndicators:"短路保护值及动作时间:",performanceDesc:'>ln*3,<0.1s'},
            {technicalIndicators:"剩余动作电流值及动作时间:",performanceDesc:'30mA,<0.1s'},
            {technicalIndicators:"剩余不动作电流:",performanceDesc:'漏电不动作电流: 15mA'},
            {technicalIndicators:"自动重合闸特性:",performanceDesc:'线路发生瞬间漏电或瞬间冲击雷电、电压时，自动重合闸漏电保护器立即断开;故障过后，线路如是安全，保护器会自动重新合闸通电。'},
            {technicalIndicators:"跳闸时间:",performanceDesc:'1分钟/2分钟/5分钟/30分钟/60分-10次'}
          ]
        }
      ],
    };
  },
  watch: {},
  components: {
    productList,
  },
  mounted: function () {},
};
</script>
<style scoped>
.content_box {
  width: 100%;

  background-color: #f3f3f3;
}
.content_box .header_box {
  width: 100%;
  height: 360px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.content_box .header_box .item {
  color: #fff;
  font-size: 40px;
}
.content_box .header_box .item_small {
  color: #fff;
  font-size: 23px;
}
.content_box .productList_content {
  padding: 20px 0px;
}
/* 关于我们 begin */
.top_big_small_box {
  margin-bottom: 0%;
  margin-top: 4%;
}
.top_big_small_box .about_top_box .gary_text {
  font-size: 42px;
  color: #555555;
}
.top_big_small_box .about_top_box .primary_color_text {
  margin-left: 10px;
  color: #313493;
  font-size: 42px;
  font-weight: bolder;
}

.top_big_small_box .top_text_box_two {
  color: #000000;
  font-size: 35px;
  margin-top: 10px;
  font-weight: bolder;
}

/* 关于我们 end */
.profile_content {
  color: #333333;
  font-size: 20px;
  width: 65%;
  line-height: 45px;
  margin-bottom: 40px;
}
</style>


// WEBPACK FOOTER //
// src/views/productConter/threePhase.vue